
import { Vue, Component, Watch, Prop, Emit } from 'vue-property-decorator';
import { BASE_URL } from '@/common/constant';
import { $delay } from '@/common/utils';
import lazyInject from '@/di';
import UserService from '@/services/user.service';
import { ISPUImageUploadOptions } from '@/common/interface/spu';

interface IImage {
  id: string;
  url: string;
  order?: number;
}

@Component({})
export default class CoverImagesModal extends Vue {
  watchable = true;

  BASE_URL = BASE_URL;

  visible = false;

  token: string | undefined = undefined;

  val: IImage[] = [];

  uploading = false;

  WHtype = true;

  /** 上传配置 */
  options: ISPUImageUploadOptions = {
    allowDuplicateUploads: false,
    target: `${BASE_URL}/tool/upload`,
    testChunks: false,
    headers: {},
    chunkSize: 5 * 1024 * 1024,
  };

  @Prop()
  value!: IImage[];

  // @Watch('val')
  // watchInternalVal(): void {
  //   this.$emit(
  //     'change',
  //     this.val,
  //   );
  //   this.$emit('updateSubmittable', this.val.length === 2);
  // }


  @Emit('update')
  updateVal() {
    return this.val;
  }

  @Watch('value')
  watchValue() {
    if (this.value && this.value.length) {
      this.val = [...this.value];
    } else {
      this.val = [];
    }
  }

  @lazyInject(UserService)
  userService!: UserService;

  // beforeUpload(file: { type: string; size: number }) {
  //   const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
  //   if (!isJpgOrPng) {
  //     this.$message.error('请上传 png/jpeg 格式的照片!');
  //   }
  //   const isLt5M = file.size / 1024 / 1024 < 5;
  //   if (!isLt5M) {
  //     this.$message.error('照片必须小于5MB!');
  //   }
  //   return isJpgOrPng && isLt5M;
  // }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private async onUploadChange(info: any, idx: number) {
    if (info.file.status === 'uploading') {
      this.uploading = true;
    }
    if (info.file.status === 'error') {
      this.uploading = false;
      const { code, error } = info.file.response;
      if (code === 400) {
        this.$message.error(error);
        await $delay(1000);
        this.$router.push({
          path: '/login',
          query: {
            redirect: this.$route.fullPath,
          },
        });
      } else {
        this.$message.error(error);
      }
    }
    if (info.file.status === 'done') {
      if (this.WHtype) {
        const { data } = JSON.parse(info.file.xhr.response);
        const result = {
          id: data[0]?.id,
          resource_id: data[0]?.id,
          url: data[0]?.url,
          path: data[0]?.url,
          title: '封图',
        };

        this.val.splice(idx, 1, result);
        this.updateVal();
      }
      this.uploading = false;
    }
  }

  handleCancel() {
    this.visible = false;
    this.val = [];
  }

  handleOk() {
    this.visible = false;
    this.$emit('updateSubmittable', this.val);
  }

  mounted() {
    this.watchValue();
    this.watchable = false;
  }

  init() {
    this.visible = true;
  }

  created() {
    this.options.headers.AUTHORIZATION = this.userService.currentUser()?.token;
    this.token = this.userService.currentUser()?.token;
  }

  private imageUrl: string | null = null;

  /**
   * 上传前校验
   */
  private beforeUpload(file: File): boolean | Promise<boolean> {
    const { type, size } = file;


    // 1. 格式校验
    const validTypes = ['image/jpeg', 'image/jpg', 'image/png'];
    if (!validTypes.includes(type)) {
      this.$message.error('仅支持 JPG、JPEG 和 PNG 格式的图片！');
      return false;
    }

    // 2. 大小校验（10MB = 10 * 1024 * 1024）
    const maxSize = 10 * 1024 * 1024;
    if (size > maxSize) {
      this.$message.error('文件大小不能超过 10MB！');
      return false;
    }
    // const img = new Image();
    // const url = URL.createObjectURL(file);
    // console.log(url);
    // img.onload = () => {
    //   console.log('宽度:', img.naturalWidth);
    //   console.log('高度:', img.naturalHeight);
    //   const width = img.naturalWidth;
    //   const height = img.naturalHeight;
    //   if (width < 900 || height < 900 || width / height !== height / width) {
    //     console.log(new Date().getTime(), 'd');

    //     this.WHtype = false;
    //     this.$message.error('图片尺寸不能小于 900x900px！');
    //     return false;
    //   } else {
    //     this.WHtype = true;
    //   }
    //   // 使用完后释放对象 URL，避免内存泄漏
    //   URL.revokeObjectURL(url);
    // };
    // img.src = url;
    return true;
  }
}
